import {BrickContext, Brick, registerBrick } from 'olympe';
import Showdown from 'showdown';

export default class HTMLToMarkdown extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} html
     * @param {function(string)} setMarkdown
     */
    update($, [html], [setMarkdown]) {
        const converter = new Showdown.Converter();
        setMarkdown(converter.makeMarkdown(html));
    }
}

registerBrick('0191a8d9c9d689edd80d', HTMLToMarkdown);
